import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMeterDashboardFilters,
  setMeterDashboardFilters,
} from "../../../../../redux/features/meter/meter-slice";
import { selectProfile } from "../../../../../redux/features/user/user-slice";
import { EDateTypes } from "../../../../../shared/oversight-core/enums/date-types";
import { UserRole } from "../../../../../shared/oversight-core/enums/user-roles";
import FilteringSidePanel from "../../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppDateRangeSelector from "../../../../../shared/oversight-core/ui-elements/app-date-range-selector/app-date-range-selector";

interface IProps {
  showFilter: boolean;
  setShowFilter: (value: boolean) => void;
}

const FilterMeterDashboardSidePanel = (props: IProps) => {
  const { showFilter, setShowFilter } = props;

  const dispatch = useDispatch();

  const meterDashboardFilterStore = useSelector(selectMeterDashboardFilters);
  const profile = useSelector(selectProfile);

  const [selectedDateType, setSelectedDateType] = useState(
    meterDashboardFilterStore.selectedDateType,
  );
  const [selectedDate, setSelectedDate] = useState(
    meterDashboardFilterStore.selectedDate,
  );

  return (
    <FilteringSidePanel
      isOpen={showFilter}
      onClose={() => {
        setShowFilter(false);
      }}
      onFilter={() => {
        dispatch(
          setMeterDashboardFilters({
            selectedDate,
            selectedDateType,
          }),
        );
        setShowFilter(false);
      }}
      onClearAll={() => {
        dispatch(
          setMeterDashboardFilters({
            selectedDate: new Date(),
            selectedDateType: EDateTypes.DAILY,
          }),
        );
        setSelectedDateType(EDateTypes.DAILY);
        setSelectedDate(new Date());
        setShowFilter(false);
      }}
    >
      <>
        <div className="mt-4">
          <AppDateRangeSelector
            startDate={selectedDate}
            endDate={new Date()}
            setSelectedDate={(startDate: Date) => {
              setSelectedDate(startDate);
            }}
            dateTypes={[
              [EDateTypes.DAILY, EDateTypes.WEEKLY, EDateTypes.MONTHLY],
            ]}
            selectedDateType={selectedDateType}
            setSelectedDateType={setSelectedDateType}
            showDatePicker={false}
            isShowDatePicker={profile?.role === UserRole.ROLE_METER_READER_USER}
          />
        </div>
      </>
    </FilteringSidePanel>
  );
};

export default FilterMeterDashboardSidePanel;
